var i = function(a, r, c) {
  var e = "react-spinners-".concat(a, "-").concat(c);
  if (typeof window > "u" || !window.document)
    return e;
  var n = document.createElement("style");
  document.head.appendChild(n);
  var t = n.sheet, o = `
    @keyframes `.concat(e, ` {
      `).concat(r, `
    }
  `);
  return t && t.insertRule(o, 0), e;
};
export {
  i as createAnimation
};
//# sourceMappingURL=animation.es.js.map
